export enum OperatorName {
  // Any
  IS = 'is',
  IS_NOT = 'isNot',

  // string
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'doesNotContain',

  // number, date
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_OR_EQUAL_TO = 'greaterThanOrEqualTo',
  LESS_THAN = 'lessThan',
  LESS_THAN_OR_EQUAL_TO = 'lessThanOrEqualTo',
}

export type OperatorDefinition = {
  name: OperatorName;
  label: string;
};

export const STRING_OPERATORS = [
  { name: OperatorName.STARTS_WITH, label: 'Starts With' },
  { name: OperatorName.ENDS_WITH, label: 'Ends With' },
  { name: OperatorName.IS, label: 'Is' },
  { name: OperatorName.IS_NOT, label: 'Is Not' },
  { name: OperatorName.CONTAINS, label: 'Contains' },
  { name: OperatorName.DOES_NOT_CONTAIN, label: 'Does Not Contain' },
] as const satisfies readonly OperatorDefinition[];

export const NUMBER_OPERATORS = [
  { name: OperatorName.IS, label: 'Is' },
  { name: OperatorName.IS_NOT, label: 'Is Not' },
  { name: OperatorName.GREATER_THAN, label: 'Greater Than' },
  { name: OperatorName.GREATER_THAN_OR_EQUAL_TO, label: 'Greater Than or Equal To' },
  { name: OperatorName.LESS_THAN, label: 'Less Than' },
  { name: OperatorName.LESS_THAN_OR_EQUAL_TO, label: 'Less Than or Equal To' },
] as const satisfies readonly OperatorDefinition[];

export const DATE_OPERATORS = [
  { name: OperatorName.IS, label: 'Is On' },
  { name: OperatorName.IS_NOT, label: 'Is Not On' },
  { name: OperatorName.GREATER_THAN, label: 'Is After' },
  { name: OperatorName.GREATER_THAN_OR_EQUAL_TO, label: 'Is On or After' },
  { name: OperatorName.LESS_THAN, label: 'Is Before' },
  { name: OperatorName.LESS_THAN_OR_EQUAL_TO, label: 'Is On or Before' },
] as const satisfies readonly OperatorDefinition[];

export const MONTH_YEAR_OPERATORS = [
  { name: OperatorName.IS, label: 'Is In' },
  { name: OperatorName.IS_NOT, label: 'Is Not In' },
  { name: OperatorName.GREATER_THAN, label: 'Is After' },
  { name: OperatorName.GREATER_THAN_OR_EQUAL_TO, label: 'Is In or After' },
  { name: OperatorName.LESS_THAN, label: 'Is Before' },
  { name: OperatorName.LESS_THAN_OR_EQUAL_TO, label: 'Is In or Before' },
] as const satisfies readonly OperatorDefinition[];

export const ENUM_OPERATORS = [
  { name: OperatorName.IS, label: 'Is' },
  { name: OperatorName.IS_NOT, label: 'Is Not' },
] as const satisfies readonly OperatorDefinition[];
